import React from "react";
import {
  Box,
  Container,
  Fab,
  Stack,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import FormatQuoteIcon from "@mui/icons-material/FormatQuote";
import { colors } from "../../assets";
import { ReviewCard, SectionHeader } from "../molecules";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Autoplay, Pagination } from "swiper";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";

export const ReviewSection = ({ title, items }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Box
      style={{
        width: "100%",
        padding: !isMobile ? "120px 0" : "60px 0",
        background: `linear-gradient(90deg, ${colors.gray4} 40%, transparent 40%)`,
      }}
    >
      <Container maxWidth="lg">
        <Stack direction="row" spacing="24px">
          {!isMobile && (
            <Stack spacing="32px" justifyContent="center">
              <Fab>
                <FormatQuoteIcon
                  style={{ color: colors.primary, fontSize: "36px" }}
                />
              </Fab>
              <SectionHeader title={title} style={{ textAlign: "start" }} />
            </Stack>
          )}

          <Swiper
            spaceBetween={8}
            slidesPerView={!isTablet ? 2 : 1}
            modules={[FreeMode, Autoplay, Pagination]}
            freeMode={true}
            autoplay={{ delay: 3000 }}
            pagination={{ clickable: true }}
            style={{
              width: "100%",
              paddingBottom: "64px",
              "--swiper-pagination-color": "white",
              "--swiper-pagination-bullet-inactive-color": colors.gray3,
              "--swiper-pagination-bullet-inactive-opacity": 1,
            }}
          >
            {items?.map((item, index) => (
              <SwiperSlide key={index}>
                <ReviewCard
                  title={item?.title}
                  description={item?.description}
                  avatar={item?.photo?.data?.attributes?.url}
                  name={item?.name}
                  position={item?.position}
                  style={{ height: !isMobile ? "600px" : "400px" }}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </Stack>
      </Container>
    </Box>
  );
};
